import { createSlice } from '@reduxjs/toolkit';
import { sendGeneralRequest} from '../generalRequest';

const initialState = {
    shouldDisplayInvoiceList: false,
    shouldDisplaySingleInvoice: false,
    shouldDisplayMainUtilityView: true,
    isTransactionSuccessfullyStarted : false,
    isTransactionSuccessfullyCompleted: false,
    isOfferTransactionSuccessfullyStarted: false,
    isOfferTransactionSuccessfullyCompleted: false,
    selectedOffer: '', 
    isConfirmationDialogOpen: false,
    subscriberBalance: '',
    transactionId: '',
    invoiceList: [],
    singleInvoice: {},
    isLoading: false
};

export const vodafoneTopupSlice = createSlice({
    name: 'vodafoneTopup',
    initialState,
    reducers:{
        displayInvoiceList : (state) => {
            state.shouldDisplayInvoiceList = true
            state.shouldDisplaySingleInvoice = false
            state.shouldDisplayMainUtilityView = false
        },
        displaySingleInvoice : (state) => {
            state.shouldDisplaySingleInvoice = true
            state.shouldDisplayInvoiceList = false
            state.shouldDisplayMainUtilityView = false
        },
        displayMainUtilityView : (state) => 
        {
            state.shouldDisplaySingleInvoice = false
            state.shouldDisplayInvoiceList = false
            state.shouldDisplayMainUtilityView = true
        },
        changeConfirmationDialogState: (state) =>
        {
            state.isConfirmationDialogOpen = !state.isConfirmationDialogOpen
        },
        setSubscriberBalance: (state, action) => 
        {
            state.subscriberBalance = action.payload
        },
        setIsOfferTransactionSuccessfullyStarted : (state, action) => 
        {
            state.isOfferTransactionSuccessfullyStarted = action.payload
        },
        setIsOfferTransactionSuccessfullyCompleted : (state, action) => 
        {
            state.isOfferTransactionSuccessfullyCompleted = action.payload
        },
        setTransactionId: (state, action) => 
        {
            state.transactionId = action.payload
        },
        setIsTransactionSuccessfullyStarted : (state, action) => 
        {
            state.isTransactionSuccessfullyStarted = action.payload
        },
        setIsTransactionSuccessfullyCompleted: (state, action) => 
        {
            state.isTransactionSuccessfullyCompleted = action.payload
        },
        setSelectedOffer: (state, action) => 
        {
            state.selectedOffer = action.payload
        },
        resetVodafoneTopUpSlice : () => initialState
    },
    extraReducers: (builder) => {
        builder
            .addCase(sendGeneralRequest.pending, (state) => {
                state.isLoading = true
            }) 
            .addCase(sendGeneralRequest.rejected, (state) => {
                state.isLoading = false
            }) 
            .addCase(sendGeneralRequest.fulfilled, (state, action) => {
                state.isLoading = false
                if(action.payload.endpoint === 'ASBS/StartVodafoneTopUPMNO')
                {         
                    state.transactionId = action.payload.response.transID
                    state.isTransactionSuccessfullyStarted = true
                }
                else if(action.payload.endpoint === 'ASBS/ConfirmVodafoneTopUPMNO')
                {         
                    state.isTransactionSuccessfullyStarted = false
                    state.isTransactionSuccessfullyCompleted = true
                    //state.subscriberBalance = action.payload.response.SubscriberBalance
                }
                else if(action.payload.endpoint === 'ASBS/GetVodafoneListOfOffers')
                {   
                    const offers = action.payload.response.offers.map(offer => (
                       offer.listProducts.map(product => {
                            return product
                        })
                    ))
                    state.invoiceList = offers.flat(1).map(offer=> ({ Emri: offer.Name, Pershkrimi: offer.productDescription, Vlera: offer.productValue + ' Leke', Id: offer.productID, Ulje: offer.discountPrice+ ' Leke'}))
                    state.subscriberBalance = action.payload.response.subscriberBalance 
                    state.shouldDisplayInvoiceList = true
                    state.shouldDisplaySingleInvoice = false
                    state.shouldDisplayMainUtilityView = false   
                    state.isTransactionSuccessfullyCompleted = false       
                }
                else if(action.payload.endpoint === 'ASBS/ConfirmVodafoneOffer')
                {         
                    state.isTransactionSuccessfullyCompleted = false
                    state.isOfferTransactionSuccessfullyStarted = false
                    state.isOfferTransactionSuccessfullyCompleted = true
                    state.shouldDisplaySingleInvoice = false
                    state.shouldDisplayInvoiceList = false
                    state.shouldDisplayMainUtilityView = true
                    state.isConfirmationDialogOpen = false
                }
                else if(action.payload.endpoint === 'DailyTransaction')
                {         
                    state.lastTransactionsData = action.payload.response.lastTransactionsData
                }
            })
    },
})
export const { displayInvoiceList, displaySingleInvoice, setIsTransactionSuccessfullyCompleted, setIsTransactionSuccessfullyStarted, resetVodafoneTopUpSlice,displayMainUtilityView, changeConfirmationDialogState, setSelectedOffer,  setTransactionId,  setSubscriberBalance } = vodafoneTopupSlice.actions;

export const selectVodafoneTopupState = (state) => state.vodafoneTopup;

export default vodafoneTopupSlice.reducer;